/** Extrae id de conversación desde deepLink de notificación operador. */
export function conversationIdFromDeepLink(deepLinkPath: string): string | null {
  const m = deepLinkPath.match(/^\/app\/conversations\/([^/?#]+)/);
  return m?.[1] ?? null;
}

export function conversationIdFromPayload(payload: unknown): string | null {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null;
  const id = (payload as { conversationId?: unknown }).conversationId;
  return typeof id === 'string' && id.trim() ? id.trim() : null;
}

/** Chat de la alerta cuando el enlace principal no abre esa conversación. */
export function chatLinkUnlessDeepLink(deepLinkPath: string, payload: unknown): string | null {
  const id = conversationIdFromPayload(payload);
  if (!id) return null;
  const path = `/app/conversations/${id}`;
  if (deepLinkPath.startsWith(path)) return null;
  return path;
}
